var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 48,
    viewBox: "0 0 130 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.043 1.18066C129.014 1.20434 129.781 2.01053 129.758 2.98134L129.372 18.8016C129.348 19.7725 128.542 20.5403 127.571 20.5166C126.6 20.4929 125.833 19.6867 125.856 18.7159L126.199 4.65341L112.137 4.31042C111.166 4.28674 110.398 3.48055 110.422 2.50974C110.446 1.53893 111.252 0.771122 112.223 0.7948L128.043 1.18066ZM1.85913 13.6263C3.87366 14.7544 9.96967 17.209 18.7728 19.5902C27.5296 21.9588 38.8445 24.2214 51.2517 25.0219C76.106 26.6254 105.067 22.3513 126.787 1.6652L129.213 4.21175C106.483 25.859 76.3537 30.1653 51.0253 28.5312C38.3412 27.7129 26.7917 25.4022 17.8546 22.9848C8.96367 20.58 2.53606 18.0359 0.140873 16.6946L1.85913 13.6263Z",
    fill: "url(#paint0_linear_2_1919)",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4502 7.52367L86.2821 5.83189L87.9739 -3.08464e-05L89.6657 5.83189L95.4976 7.52367L89.6657 9.21544L87.9739 15.0474L86.2821 9.21544L80.4502 7.52367Z",
    fill: "url(#paint1_linear_2_1919)",
    fillOpacity: 0.74
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2449 7.52367L86.4214 6.31209L86.6857 6.23544L86.7623 5.97119L87.9739 1.79463L89.1855 5.97119L89.2621 6.23544L89.5264 6.31209L93.7029 7.52367L89.5264 8.73524L89.2621 8.8119L89.1855 9.07614L87.9739 13.2527L86.7623 9.07614L86.6857 8.8119L86.4214 8.73524L82.2449 7.52367Z",
    stroke: "url(#paint2_linear_2_1919)",
    strokeOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8818 39.4241L29.9144 38.5444L30.7942 35.5118L31.6739 38.5444L34.7065 39.4241L31.6739 40.3038L30.7942 43.3364L29.9144 40.3038L26.8818 39.4241Z",
    fill: "url(#paint3_linear_2_1919)",
    fillOpacity: 0.74
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6765 39.4241L30.0537 39.0246L30.318 38.9479L30.3946 38.6837L30.7942 37.3064L31.1937 38.6837L31.2703 38.9479L31.5346 39.0246L32.9118 39.4241L31.5346 39.8236L31.2703 39.9003L31.1937 40.1645L30.7942 41.5418L30.3946 40.1645L30.318 39.9003L30.0537 39.8236L28.6765 39.4241Z",
    stroke: "url(#paint4_linear_2_1919)",
    strokeOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4406 43.6375L80.4732 42.7578L81.3529 39.7252L82.2327 42.7578L85.2653 43.6375L82.2327 44.5172L81.3529 47.5498L80.4732 44.5172L77.4406 43.6375Z",
    fill: "url(#paint5_linear_2_1919)",
    fillOpacity: 0.74
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2353 43.6375L80.6125 43.238L80.8768 43.1613L80.9534 42.8971L81.3529 41.5198L81.7525 42.8971L81.8291 43.1613L82.0934 43.238L83.4706 43.6375L82.0934 44.037L81.8291 44.1137L81.7525 44.3779L81.3529 45.7551L80.9534 44.3779L80.8768 44.1137L80.6125 44.037L79.2353 43.6375Z",
    stroke: "url(#paint6_linear_2_1919)",
    strokeOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1919",
    x1: 1,
    y1: 21.6079,
    x2: 81.4333,
    y2: 21.6079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1919",
    x1: 87.9739,
    y1: 15.0474,
    x2: 87.9739,
    y2: -0.0000308464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1919",
    x1: 59.265,
    y1: 18.1753,
    x2: 59.7354,
    y2: -1.19651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1919",
    x1: 30.7942,
    y1: 43.3364,
    x2: 30.7942,
    y2: 35.5118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_1919",
    x1: 15.8656,
    y1: 44.963,
    x2: 16.1101,
    y2: 34.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_1919",
    x1: 81.3529,
    y1: 47.5498,
    x2: 81.3529,
    y2: 39.7252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_1919",
    x1: 66.4243,
    y1: 49.1763,
    x2: 66.6689,
    y2: 39.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A428"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.343879bb33d8270f0c65599ebf310ae1.svg";
export { ForwardRef as ReactComponent };